const SET_ARTICLES = (state, articles) => {
  state.articles = articles
}

const SET_CART = (state, cart) => {
  state.cart = cart
}

const SET_COUNTRIES = (state, countries) => {
  state.countries = countries
}

const SET_CART_STATUS = (state, cartStatus) => {
  state.cartStatus = cartStatus
}

const SET_DELIVERY_DATA = (state, boolDelivery) => {
  state.isDeliveryEmpty = boolDelivery
}

const SET_GAMMES = (state, gammes) => {
  state.gammes = gammes
}

const SET_HEADER_TITLE = (state, headerTitle) => {
  state.headerTitle = headerTitle
}

const SET_LINE_CART = (state, linesCart) => {
  state.linesCart = linesCart
  state.linesCartLength = linesCart.length
}

const SET_ORDERS_LIST_V2 = (state, ordersList) => {
  state.ordersListV2 = ordersList
}
const SET_TOKEN_PROPERTIES = (state, tokenData) => {
  state.token = tokenData
}

const SET_USER = (state, user) => {
  state.user = user
}

const REMOVE_TOKEN = (state) => {
  state.token = null
  state.user = null
  state.cart = null
}

const VALIDATE_CART = (state) => {
  state.cart = null,
  state.cartStatus = null,
  state.linesCart = [],
  state.linesCartLength = 0
}

const UPDATE_CART_LOADING = (state, bool) => {
  state.isLoadingCart = bool
}

export default {
  REMOVE_TOKEN,
  SET_ARTICLES,
  SET_CART,
  SET_CART_STATUS,
  SET_COUNTRIES,
  SET_DELIVERY_DATA,
  SET_GAMMES,
  SET_HEADER_TITLE,
  SET_LINE_CART,
  SET_ORDERS_LIST_V2,
  SET_TOKEN_PROPERTIES,
  SET_USER,
  UPDATE_CART_LOADING,
  VALIDATE_CART
}